export default "__VITE_ASSET__Cc9PB0we__"